import { render, staticRenderFns } from "./ImageLazy.vue?vue&type=template&id=c34bcf56&scoped=true&"
import script from "./ImageLazy.vue?vue&type=script&lang=js&"
export * from "./ImageLazy.vue?vue&type=script&lang=js&"
import style0 from "./ImageLazy.vue?vue&type=style&index=0&id=c34bcf56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34bcf56",
  null
  
)

export default component.exports